// src/components/services/AILegalResearcher/constants.js
export const queryTypes = [
  {
    value: 'case_summaries',
    label: 'Search by Case Summaries',
    description: 'Search through comprehensive case summaries to find relevant legal precedents',
    examples: [
      "Summarize recent High Court cases on the application of the doctrine of legitimate expectation in administrative law.",
      "Provide summaries of cases dealing with the enforcement of foreign arbitral awards in Kenya.",
      "What are the key elements considered in case summaries involving disputes over intellectual property rights in the tech industry?",
      "Summarize cases where the principle of 'polluter pays' has been a central issue in environmental litigation."
    ]
  },
  {
    value: 'case_sub_type',
    label: 'Search by Case Sub Type',
    description: 'Filter cases by specific legal categories and subcategories',
    examples: [
      "Find recent appellate decisions on tax disputes involving transfer pricing.",
      "What are the key cases categorized under medical negligence in the last five years?",
      "Show cases classified under 'breach of contract' with a focus on liquidated damages clauses.",
      "Identify cases sub-typed as 'judicial review' involving decisions of the Communications Authority of Kenya."
    ]
  },
  {
    value: 'prayer',
    label: 'Search by Prayer',
    description: 'Search based on the remedies or relief sought in cases',
    examples: [
      "What are the common prayers sought in petitions challenging the constitutionality of legislation?",
      "Analyze cases where plaintiffs sought specific performance in disputes involving technology transfer agreements.",
      "Identify cases where parties have sought an Anton Piller order in intellectual property disputes.",
      "What is the success rate of prayers for mandamus against public bodies in Kenya?"
    ]
  },
  {
    value: 'legal_precedents',
    label: 'Search by Legal Precedents',
    description: 'Find important cases that have set legal precedents',
    examples: [
      "What are the landmark Supreme Court cases that have shaped the interpretation of Article 27 of the Constitution (equality and freedom from discrimination)?",
      "Identify the key Court of Appeal precedents on the admissibility of digital evidence in criminal proceedings.",
      "Which cases established the precedents for determining child custody in contentious divorce matters?",
      "What are the leading authorities on the application of the 'Bolam Test' in medical negligence cases?"
    ]
  },
  {
    value: 'legal_principles',
    label: 'Search by Principles of Judgement',
    description: 'Search for cases based on key legal principles established in judgments',
    examples: [
      "Explain the legal principles governing the determination of 'fair administrative action' as established in Kenyan case law.",
      "What are the key principles applied by courts when determining whether a limitation of a fundamental right is justifiable under Article 24?",
      "Analyze the principles used by courts to determine the existence of a 'duty of care' in negligence cases involving professionals.",
      "How have courts defined and applied the principle of 'public participation' in environmental decision-making?"
    ]
  },
  {
    value: 'legal_issues_raised',
    label: 'Search by Issues Raised',
    description: 'Find cases based on specific legal issues discussed',
    examples: [
      "What are the recurring legal issues raised in cases challenging the validity of public procurement awards?",
      "Identify cases where the interpretation of Article 43 on economic and social rights has been a central issue.",
      "What are the key legal issues addressed in cases involving the right to privacy in the context of data protection?",
      "Analyze cases where the 'best interests of the child' principle was a major issue in determining custody or guardianship."
    ]
  }
];